import { ReactNode, useRef, useState } from 'react';

import { exportKimTableToXlsx } from '../../utils/export-kim-table';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import { cn } from '@/new/lib/utils';

const TABLE_CELL_CLASSES =
  'w-full border-separate border-spacing-0 [&_th:not(:first-child)]:border-l [&_th]:border-gray-200 [&_th]:bg-gray-50 [&_th]:px-3 [&_th]:text-gray-600 [&_th]:whitespace-nowrap [&_th]:py-2.25 [&_th]:text-left [&_th]:font-normal [&_td]:border-t [&_td:not(:first-child)]:border-l [&_td]:border-gray-200 [&_td]:px-3 [&_td]:py-2.25 [&_td]:align-top [&_thead_tr:first-child_th:first-child]:rounded-tl-md [&_thead_tr:first-child_th:last-child]:rounded-tr-md [&_tbody_tr:last-child_td:first-child]:rounded-bl-md [&_tbody_tr:last-child_td:last-child]:rounded-br-md';

export function KimTable({ children, hideActions = false }: { children: ReactNode; hideActions?: boolean }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const tableRef = useRef<HTMLTableElement>(null);

  return (
    <div className="not-prose relative -mx-2 my-5 w-[calc(100%+1rem)] max-w-[calc(100%+1rem)] min-w-0 font-sans text-xs">
      {!hideActions && (
        <div className="flex items-center justify-end gap-1 px-2 pb-1.5">
          <Button
            type="button"
            variant="ghost"
            size="sm"
            aria-label="Export table as Excel"
            onClick={() => {
              if (tableRef.current) exportKimTableToXlsx(tableRef.current);
            }}
            className="px-1"
          >
            <Icon className="lucide--arrow-up-right" />
            Export to Excel
          </Button>

          <Button
            type="button"
            variant="ghost"
            size="sm"
            aria-label={isExpanded ? 'Collapse table' : 'Expand table'}
            onClick={() => setIsExpanded((expanded) => !expanded)}
            className="px-1"
          >
            <Icon className={cn(isExpanded ? 'lucide--fold-horizontal' : 'lucide--unfold-horizontal')} />
            {isExpanded ? 'Contract' : 'Expand'}
          </Button>
        </div>
      )}
      <div
        className={cn(
          'min-w-0 overflow-x-auto rounded-md border border-gray-200 bg-white',
          isExpanded ? 'relative left-1/2 w-[100cqw] max-w-[100cqw] -translate-x-1/2' : 'w-full max-w-full',
        )}
      >
        <table ref={tableRef} className={TABLE_CELL_CLASSES}>
          {children}
        </table>
      </div>
    </div>
  );
}
